import React, { useState } from 'react';
import { FaQrcode, FaLink, FaCopy, FaTimes } from 'react-icons/fa';
import { getBlob } from '../../helpers/apiHelper';
import Swal from 'sweetalert2';

const ShareCatalogoModal = ({ isOpen, onClose, marcaId }) => {
    const [loading, setLoading] = useState(false);
    const catalogUrl = `${window.location.origin}/productos/${marcaId}`;

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(catalogUrl);
            Swal.fire({
                title: '¡Enlace copiado!',
                text: 'El enlace ha sido copiado al portapapeles',
                icon: 'success',
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
            });
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: 'No se pudo copiar el enlace',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
        }
    };

    const handleDownloadQR = async () => {
        setLoading(true);
        try {
            const blob = await getBlob(`productos/${marcaId}/qr`);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `catalogo-qr-${marcaId}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: 'No se pudo descargar el código QR',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed z-50 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen p-4 text-center sm:p-0">
                {/* Overlay */}
                <div className="fixed inset-0 transition-opacity" aria-hidden="true" onClick={onClose}>
                    <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                {/* Modal */}
                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-medium leading-6 text-gray-900 flex items-center">
                                <FaQrcode className="mr-2" />
                                Compartir Catálogo
                            </h3>
                            <button
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-500 transition-colors"
                            >
                                <FaTimes className="h-5 w-5" />
                            </button>
                        </div>

                        {/* Content */}
                        <div className="space-y-4">
                            {/* Link Section */}
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <FaLink className="text-gray-400 mr-2" />
                                        <span className="text-sm text-gray-500 truncate">
                                            {catalogUrl}
                                        </span>
                                    </div>
                                    <button
                                        onClick={handleCopyLink}
                                        className="ml-2 p-2 text-blue-600 hover:text-blue-700 transition-colors"
                                        title="Copiar enlace"
                                    >
                                        <FaCopy className="h-5 w-5" />
                                    </button>
                                </div>
                            </div>

                            {/* QR Section */}
                            <div className="text-center">
                                <button
                                    onClick={handleDownloadQR}
                                    disabled={loading}
                                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-400 disabled:cursor-not-allowed"
                                >
                                    {loading ? (
                                        <>
                                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Generando QR...
                                        </>
                                    ) : (
                                        <>
                                            <FaQrcode className="mr-2" />
                                            Descargar QR
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareCatalogoModal; 